import { z } from 'zod';

/**
 * Cursor-based pagination (см. GDD §1.5).
 * Используется во всех list-endpoints.
 */
export const paginationQuerySchema = z.object({
  after: z.string().min(1).max(255).optional(),
  before: z.string().min(1).max(255).optional(),
  limit: z.coerce.number().int().min(1).max(200).default(50),
});

export type PaginationQuery = z.infer<typeof paginationQuerySchema>;

export const sortDirSchema = z.enum(['asc', 'desc']).default('desc');
export type SortDir = z.infer<typeof sortDirSchema>;

/**
 * Generic page envelope для всех list-ответов.
 * `T` — Zod-схема одного элемента.
 */
export const pageSchema = <T extends z.ZodTypeAny>(item: T) =>
  z.object({
    data: z.array(item),
    next_cursor: z.string().nullable(),
    has_more: z.boolean(),
  });

export type Page<T> = {
  data: T[];
  next_cursor: string | null;
  has_more: boolean;
};
